namespace GeniuzPOS.InitialData {
    export interface PsCorperateMessageRow {
        Id?: number;
        Status?: number;
        StartDate?: string;
        EndDate?: string;
        TimeFg?: TimeFg;
        StartTime?: string;
        EndTime?: string;
        Topic?: string;
        Desc?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
        ActiveBy?: string;
        Activedate?: string;
    }

    export namespace PsCorperateMessageRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Topic';
        export const localTextPrefix = 'InitialData.PsCorperateMessage';
        export const lookupKey = 'InitialData.PsCorperateMessage';

        export function getLookup(): Q.Lookup<PsCorperateMessageRow> {
            return Q.getLookup<PsCorperateMessageRow>('InitialData.PsCorperateMessage');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:ประกาศ:Modify';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:ประกาศ:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:ประกาศ:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:ประกาศ:Modify';

        export declare const enum Fields {
            Id = "Id",
            Status = "Status",
            StartDate = "StartDate",
            EndDate = "EndDate",
            TimeFg = "TimeFg",
            StartTime = "StartTime",
            EndTime = "EndTime",
            Topic = "Topic",
            Desc = "Desc",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate",
            ActiveBy = "ActiveBy",
            Activedate = "Activedate"
        }
    }
}
